import { Pipe, PipeTransform, inject } from '@angular/core';
import { DateTime } from 'luxon';
import { TranslocoService } from '@jsverse/transloco';
import { NotificationResponse } from '@domain/notifications/notifications';

@Pipe({
	name: 'notificationTitle',
	standalone: true,
})
export class NotificationTitlePipe implements PipeTransform {
	private transloco = inject(TranslocoService);

	/** Inserted by Angular inject() migration for backwards compatibility */
	constructor(...args: unknown[]);

	constructor() {}

	transform(value: NotificationResponse) {
		const sentAt = value.sentAt || '';
		const day = DateTime.fromISO(sentAt, {
			locale: this.transloco.getActiveLang(),
		}).toRelativeCalendar();
		const time = DateTime.fromISO(sentAt, {
			locale: this.transloco.getActiveLang(),
		}).toLocaleString(DateTime.TIME_24_SIMPLE);
		return {
			day,
			time,
		}
	}
}
